import { Component, Inject, Input, OnInit, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { VhQueryAutoWeb, VhEventMediator } from 'vhautowebdb';
import { FunctionService } from 'vhobjects-service/src/services';
import { isPlatformBrowser } from '@angular/common';
import { ThemeService } from 'vhobjects-service/src/services';
import { ChooseIconComponent } from 'vhobjects-service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'atw-payment-method-config',
  templateUrl: './payment-method-config.component.html',
  styleUrls: ['./payment-method-config.component.scss'],
})
export class AtwPaymentMethodConfig implements OnInit {
  @Input() objectChoosing: any;
  @Input() device: any;
  @Input() class: any;
  @Input() config: any;
  @Input() staticdata: any;
  @Input() type: any;

  width: number = 0;
  height: number = 0;
  backgroundColor: any = [];

  constructor(
    private vhEventMediator: VhEventMediator,
    public functionService: FunctionService,
    private vhQueryAutoWeb: VhQueryAutoWeb,
    public themeService: ThemeService,
    private dialog: MatDialog,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit(): void { }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    this.ensureStyleBuckets();
    this.ensureConfigDefaults();
    setTimeout(() => {
      if (isPlatformBrowser(this.platformId)) {
        const el = document.getElementById(this.objectChoosing._id);
        if (el) {
          this.width = el.clientWidth;
          this.height = el.clientHeight;
        }
      }
    }, 0);
  }

  ensureStyleBuckets(): void {
    if (!this.class) return;
    const buckets = [
      'title',
      'payment-method-selector',
      'option-delivery',
      'option-delivery-icon',
      'option-delivery-label',
      'option-delivery-description',
      'option-pickup',
      'option-pickup-icon',
      'option-pickup-label',
      'option-pickup-description',
      'option-pickup-badge',
      'option-delivery-selected',
      'option-delivery-icon-selected',
      'option-delivery-label-selected',
      'option-pickup-selected',
      'option-pickup-icon-selected',
      'option-pickup-label-selected',
      'pickup-status-title',
      'pickup-status-subtitle',
      'pickup-status-title-out',
      'pickup-status-subtitle-out',
      'pickup-action-button',
      'pickup-action-button-icon',
      'pickup-action-button-label',
      'pickup-info-title',
      'pickup-info-row',
      'modal-box',
      'modal-header-title',
      'modal-item-name',
      'modal-item-subtitle',
      'modal-stock-label',
      'modal-stock-label-out',
      'modal-quantity', 
    ];
    buckets.forEach((key) => {
      if (!this.class[key]) this.class[key] = {};
    });
  }

  ensureConfigDefaults(): void {
    if (!this.config) return;
    this.config.show_title = this.config.show_title ?? true;
    this.config.default_selected = this.config.default_selected || 'pickup';
    this.config.hide_delivery = this.config.hide_delivery ?? false;
    this.config.hide_pickup = this.config.hide_pickup ?? false;
    this.config.icon_delivery = this.config.icon_delivery || {
      icon_disable: true,
      icon_name: 'local_shipping',
    };
    this.config.icon_pickup = this.config.icon_pickup || {
      icon_disable: true,
      icon_name: 'storefront',
    };
    this.config.icon_action_button = this.config.icon_action_button || {
      icon_disable: true,
      icon_name: 'chevron_right',
    };
    this.config.icon_in_stock = this.config.icon_in_stock || {
      icon_disable: true,
      icon_name: 'check_circle',
    };
    this.config.icon_out_of_stock = this.config.icon_out_of_stock || {
      icon_disable: true,
      icon_name: 'cancel',
    };
    this.config.pickup = this.config.pickup || {
      show_badge: true,
      show_status: true,
      show_action_button: true,
      show_info_block: true,
      show_modal: true,
    };

    if (this.staticdata && !this.staticdata['modal_quantity_label']) {
      this.staticdata['modal_quantity_label'] = 'Số lượng còn lại:';
      this.staticdata['modal_quantity_label_vn'] = 'Số lượng còn lại:';
    }
    if (!this.class['modal-quantity'] || Object.keys(this.class['modal-quantity']).length === 0) {
      this.class['modal-quantity'] = {"font-family": "'Roboto', sans-serif",
        "font-weight": "500",
        "text-decoration": "none",
        "font-size": "14px",
        "font-style": "normal",
        "text-align": "left",
        "color": "#101828",
        "margin-top": "16px",
        "padding-top": "0",
        "padding-right": "0",
        "padding-bottom": "0",
        "padding-left": "0"}
        this.updateClass();
    }
  }

  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu8: false,
  };
  openHandler(value: string): void {
    Object.keys(this.openMap).forEach((key) => {
      if (key !== value) this.openMap[key] = false;
    });
  }

  openSubMap: { [key: string]: boolean } = {};

  menu3Keys = ['menu3_bo_cuc', 'menu3_tieu_de', 'menu3_khoang_dem', 'menu3_mau_nen', 'menu3_kieu_vien'];

  menu4Keys = [
    'menu4_nhan',
    'menu4_mo_ta',
    'menu4_mau_nen',
    'menu4_kieu_vien',
    'menu4_khoang_dem',
    'menu4_bieu_tuong',
    'menu4_bieu_tuong_selected',
    'menu4_mau_nen_selected',
    'menu4_kieu_vien_selected',
    'menu4_nhan_selected',
  ];

  menu5Keys = [
    'menu5_nhan',
    'menu5_mo_ta',
    'menu5_huy_hieu',
    'menu5_mau_nen',
    'menu5_kieu_vien',
    'menu5_khoang_dem',
    'menu5_bieu_tuong',
    'menu5_bieu_tuong_selected',
    'menu5_trang_thai',
    'menu5_nut_hanh_dong',
    'menu5_thong_tin',
    'menu5_mau_nen_selected',
    'menu5_kieu_vien_selected',
    'menu5_nhan_selected',
  ];

  menu6Keys = [
    'menu6_hop_thoai',
    'menu6_tieu_de',
    'menu6_van_ban',
    'menu6_phu_de',
    'menu6_ton_kho',
    'menu6_ton_kho_out',
    'menu6_so_luong', 
  ];

  toggleSub(key: string, groupKeys: string[]): void {
    const isOpening = !this.openSubMap[key];
    groupKeys.forEach((k) => (this.openSubMap[k] = false));
    this.openSubMap[key] = isOpening;
  }

  sections = [
    {
      title: 'tieu_de',
      fields: [
        { label: 'noi_dung_tieu_de', model: 'title' },
      ],
    },
    {
      title: 'giao_hang_tan_noi',
      fields: [
        { label: 'nhan', model: 'delivery_label' },
        { label: 'mo_ta', model: 'delivery_description' },
      ],
    },
    {
      title: 'nhan_tai_cua_hang',
      fields: [
        { label: 'nhan', model: 'pickup_label' },
        { label: 'mo_ta', model: 'pickup_description' },
        { label: 'noi_dung_huy_hieu', model: 'pickup_badge_text' },
      ],
    },
    {
      title: 'trang_thai_va_nut_hanh_dong',
      fields: [
        { label: 'tieu_de_trang_thai', model: 'pickup_status_title' },
        { label: 'mo_ta_trang_thai', model: 'pickup_status_subtitle' },
        { label: 'tieu_de_trang_thai_het_hang', model: 'pickup_status_title_out' },
        { label: 'mo_ta_trang_thai_het_hang', model: 'pickup_status_subtitle_out' },
        { label: 'nhan_nut_hanh_dong', model: 'pickup_action_button_label' },
      ],
    },
    {
      title: 'thong_tin_cua_hang',
      fields: [
        { label: 'tieu_de', model: 'pickup_info_title' },
        { label: 'dia_chi', model: 'pickup_info_address' },
        { label: 'nhan_xem_ban_do', model: 'pickup_info_map_label' },
        { label: 'gio_lam_viec', model: 'pickup_info_hours' },
        { label: 'hotline', model: 'pickup_info_hotline' },
      ],
    },
    {
      title: 'hop_thoai_kiem_tra_ton_kho',
      fields: [
        { label: 'tieu_de_hop_thoai', model: 'modal_title' },
        { label: 'nhan_con_hang', model: 'modal_in_stock_label' },
        { label: 'nhan_het_hang', model: 'modal_out_of_stock_label' },
        { label: 'nhan_so_luong', model: 'modal_quantity_label' },
      ],
    },
  ];

  updateConfig(): void {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, {
      [this.device + '_config']: this.config,
    });
  }

  updateClass(): void {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, {
      [this.device + '_class']: this.class,
    });
  }

  updateObject(): void {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, {
      [this.device + '_class']: this.class,
      [this.device + '_config']: this.config,
      staticdata: this.staticdata,
    });
  }

  updateStaticData(): void {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.staticdata });
  }

  changeWidthHeight(event: { width?: number; height?: number }): void {
    if (event.width) this.class['payment-method-selector']['width'] = event.width + 'px';
    if (event.height) this.class['payment-method-selector']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({
      status: 'update-object-selected-ruler',
      code: this.objectChoosing._id,
    });
    this.updateClass();
  }

  hexToRGB(hex: string): string {
    hex = hex.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return `${r}, ${g}, ${b}`;
  }

  chooseBg(bgColor: any, event: any, classBucket: string): void {
    if (!isPlatformBrowser(this.platformId)) return;
    const activeGradient = document.querySelector('.container-color .active') as HTMLElement;
    if (activeGradient) activeGradient.classList.remove('active');
    event.currentTarget.classList.add('active');
    this.class[classBucket]['background-color'] = bgColor.bgColor;
    this.updateObject();
  }

  openDialogChooseIcon(iconConfig: { icon_name?: string }): void {
    const dialogRef = this.dialog.open(ChooseIconComponent, {
      width: '80vw',
      height: '70vh',
      disableClose: false,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        iconConfig.icon_name = result.icon;
        this.updateConfig();
      }
    });
  }
}